module.exports = __webpack_public_path__ + "static/media/Kickstarter.d29fe55c.svg";